<template>
    <datepicker
        class="my-datepicker"
        :class="{'active': !!date}"
        :first-day-of-week="1"
        :lang="lang[$i18n.locale]"
        :input-class="customClass"
        :format="'DD.MM.YYYY'"
        :type="'date'"
        :clearable="clearable"
        v-model="date"
        @change="changeDate"
        :placeholder="''"
        :popup-class="'adp-modal-datepicker'"
        :disabled-date="disabledRange"
        :range="range"
        :default-value="defaultDate"
    />
</template>

<script>
import Datepicker from 'vue2-datepicker';

export default {

  name: 'wrap-datepicker',

  components: {
    Datepicker
  },

  props: {
    customClass: {
      type: String,
      default: ""
    },
    dates: {
      type: Date | Array,
    },
    disabledBefore: {
      type: Date,
    },
    disabledAfter: {
      type: Date,
    },
    range: {
      type: Boolean,
      default: () => false,
    },
    clearable: {
      type: Boolean,
      default: () => true,
    },
    notDisableRange: {
      type: Boolean,
      default: () => false,
    },
    idpYear: {
      default: null
    }
  },

  data() {
    return {
      lang: {
        ru: {
          days: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
          months: ['Янв', 'Фев', 'Март', 'Апр', 'Май', 'Июнь', 'Июль', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
          placeholder: {
            date: 'Выберите дату',
            dateRange: 'Выберите диапазон дат'
          },
          formatLocale: {
            firstDayOfWeek: 1,
            months: ['Янв', 'Фев', 'Март', 'Апр', 'Май', 'Июнь', 'Июль', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
            monthsShort: ['Янв', 'Фев', 'Март', 'Апр', 'Май', 'Июнь', 'Июль', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
          },
          monthBeforeYear: false,
        },
        en: {
          days: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
          months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          placeholder: {
            date: 'Choose date',
            dateRange: 'Choose daterange'
          },
          formatLocale: {
            firstDayOfWeek: 1,
            months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          },
          monthBeforeYear: false,
        },
        fr: {
          days: ['di', 'lu', 'ma', 'me', 'je', 've', 'sa'],
          months: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
          placeholder: {
            date: 'Choisissez une date',
            dateRange: 'Sélectionnez la plage de dates'
          },
          formatLocale: {
            firstDayOfWeek: 1,
            months: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
            monthsShort: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
          },
          monthBeforeYear: false,
        },
      },
      date: new Date(),
    }
  },

  methods: {
    changeDate() {
      this.$emit('change', this.date);
    },
    disabledRange (date) {
      if (this.notDisableRange) {
        return false;
      }
      if (this.disabledAfter && this.disabledBefore) {
        return date < this.disabledBefore || date > this.disabledAfter;
      }
      if (this.disabledBefore) {
        return date < this.disabledBefore;
      }

      if (this.idpYear === null) {
        return date < new Date(new Date().setHours(0, 0, 0, 0));
      } else {
        return date < new Date(this.idpYear, 0, 1) || date > new Date(this.idpYear, 11, 31)
      }
    },
  },

  computed: {
    defaultDate() {
      let currentDate = new Date();
      if (this.idpYear !== null) {
        currentDate = new Date(this.idpYear, currentDate.getMonth(), currentDate.getDate());
      }
      return currentDate;
    }
  },

  mounted() {
    this.date = this.dates;
  }
}
</script>
